import React, { useEffect, useRef, useState } from "react";
import "./style.scss";

type TagDisplayProps = {
  tags: string[];
};

const TagDisplay: React.FC<TagDisplayProps> = ({ tags }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const allTagsRef = useRef<HTMLDivElement>(null);
  const [visibleTags, setVisibleTags] = useState<string[]>([]);
  const [showEllipsis, setShowEllipsis] = useState(false);
  const [hiddenCount, setHiddenCount] = useState(0);

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      calculateVisibleTags();
    });

    if (containerRef.current) observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    calculateVisibleTags();
  }, [tags]);

  const calculateVisibleTags = () => {
    const container = containerRef.current;
    const allTags = allTagsRef.current;
    if (!container || !allTags) return;

    const tagElements = Array.from(allTags.children) as HTMLSpanElement[];
    const availableWidth = container.offsetWidth - 40;

    let totalWidth = 0;
    const visible: string[] = [];

    for (let i = 0; i < tagElements.length; i++) {
      const tagWidth = tagElements[i].offsetWidth + 8;
      if (totalWidth + tagWidth <= availableWidth) {
        totalWidth += tagWidth;
        visible.push(tags[i]);
      } else {
        if (i === 0) {
          setVisibleTags([tags[0]]);
          setShowEllipsis(true);
          setHiddenCount(tags.length - 1);
        } else {
          setVisibleTags(visible);
          setShowEllipsis(false);
          setHiddenCount(tags.length - visible.length);
        }
        return;
      }
    }

    setVisibleTags(visible);
    setHiddenCount(0);
    setShowEllipsis(false);
  };

  return (
    <div className="tag-container" ref={containerRef}>
      <div className="tag-container__wrapper">
        {visibleTags.map((tag, i) => (
          <span
            key={i}
            className={`tag-container__tag ${showEllipsis && i === 0 ? "truncate" : ""}`}
          >
            #{tag}
            {i < visibleTags.length - 1 ? "," : ""}
            {showEllipsis && i === 0 ? "..." : ""}
          </span>
        ))}
        {hiddenCount > 0 && (
          <span className="tag-container__extra">+{hiddenCount}</span>
        )}

        <div className="hidden-tag-measure" ref={allTagsRef}>
          {tags.map((tag, i) => (
            <span key={i} className="tag-container__tag">
              #{tag}
              {i < tags.length - 1 ? "," : ""}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TagDisplay;
